import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-modal-associar-card',
  templateUrl: './modal-associar-card.component.html',
  styleUrls: ['./modal-associar-card.component.scss']
})
export class ModalAssociarCardComponent implements OnInit {

  @Input() nome: string;
  @Input() cpf: string;
  @Input() matricula: string;

  @ViewChild("card", null)

  private card: ElementRef;
  public formModalCard = null;

  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalAssociarCardComponent>
    ) {

      this.formModalCard = this.formBuilder.group({
        nroCard: [null],
        nome: [null],
        cpf: [null],
        matricula: [null],
      });

    }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();

  }

  dismiss() {
    this.ref.close();
  }

}
